<div style="margin-left: 5vw; margin-top: 10vh; width: 90vw">
   <div style="padding-bottom: 5vh">
      <div class="right-align" style="padding-bottom: 5px">
         <button
            mat-stroked-button
            color="primary"
            (click)="openDialog()"
            style="border-radius: 1000px"
         >
            <mat-icon>upload</mat-icon>
            {{ 'Import' | translate }}
         </button>
      </div>
      <form [formGroup]="searchForm">
         <mat-form-field style="min-width: 20%">
            <input matInput formControlName="searchField" />
            <mat-label>{{ 'Search' | translate }}</mat-label>
         </mat-form-field>
      </form>

      <mat-expansion-panel>
         <mat-expansion-panel-header>
            <mat-panel-description> {{ 'Filter content' | translate }} </mat-panel-description>
         </mat-expansion-panel-header>

         <form [formGroup]="filterForm" class="filter-form">
            <mat-form-field>
               <input
                  matInput
                  formControlName="name"
                  (keydown.enter)="onFilter(); $event.stopPropagation()"
               />
               <mat-label>{{ 'Student name' | translate }}</mat-label>
            </mat-form-field>

            <mat-form-field>
               <mat-label>{{ 'Birth date' | translate }}</mat-label>
               <input
                  matInput
                  formControlName="birthDate"
                  [matDatepicker]="birthDatePicker"
                  (input)="onParsedFilterDateInput($event, 'birthDate')"
                  (keydown.enter)="onFilter(); $event.stopPropagation()"
               />
               <mat-datepicker-toggle matSuffix [for]="birthDatePicker"></mat-datepicker-toggle>
               <mat-datepicker #birthDatePicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field>
               <mat-label>{{ 'Area' | translate }}</mat-label>

               <mat-select
                  [placeholder]="'Area' | translate"
                  formControlName="area"
                  (keydown.enter)="onFilter(); $event.stopPropagation()"
                  #areaSelect
               >
                  <mat-option *ngFor="let area of areas" [value]="area.code">
                     {{ area.value }}
                  </mat-option>
               </mat-select>
               <button
                  *ngIf="filterForm.get('area')?.value"
                  matSuffix
                  mat-icon-button
                  aria-label="Clear"
                  type="button"
                  (click)="
                     filterForm.get('area')?.reset(); areaSelect.focus(); $event.stopPropagation()
                  "
               >
                  <mat-icon>close</mat-icon>
               </button>
            </mat-form-field>

            <mat-form-field>
               <input
                  matInput
                  formControlName="createdBy"
                  (keydown.enter)="onFilter(); $event.stopPropagation()"
               />
               <mat-label>{{ 'Created by' | translate }}</mat-label>
            </mat-form-field>

            <mat-form-field>
               <mat-select
                  formControlName="rowStatus"
                  (keydown.enter)="onFilter(); $event.stopPropagation()"
                  #rowStatusSelect
               >
                  <mat-option *ngFor="let rs of rowStatuses" [value]="rs">
                     {{ rs | translate }}
                  </mat-option>
               </mat-select>
               <mat-label>{{ 'Row status' | translate }}</mat-label>
               <button
                  *ngIf="filterForm.get('rowStatus')?.value"
                  matSuffix
                  mat-icon-button
                  aria-label="Clear"
                  type="button"
                  (click)="
                     filterForm.get('rowStatus')?.reset();
                     rowStatusSelect.focus();
                     $event.stopPropagation()
                  "
               >
                  <mat-icon>close</mat-icon>
               </button>
            </mat-form-field>

            <mat-form-field>
               <mat-select
                  formControlName="studentStatus"
                  (keydown.enter)="onFilter(); $event.stopPropagation()"
                  placeholder="Student status"
                  #studentStatusSelect
               >
                  <mat-option *ngFor="let ss of studentStatuses" [value]="ss">
                     {{ ss | translate }}
                  </mat-option>
               </mat-select>
               <button
                  *ngIf="filterForm.get('studentStatus')?.value"
                  matSuffix
                  mat-icon-button
                  aria-label="Clear"
                  type="button"
                  (click)="
                     filterForm.get('studentStatus')?.reset();
                     studentStatusSelect.focus();
                     $event.stopPropagation()
                  "
               >
                  <mat-icon>close</mat-icon>
               </button>
               <mat-label>{{ 'Student status' | translate }}</mat-label>
            </mat-form-field>

            <mat-form-field>
               <input
                  matInput
                  formControlName="project"
                  (keydown.enter)="onFilter(); $event.stopPropagation()"
               />
               <mat-label>{{ 'Project' | translate }}</mat-label>
            </mat-form-field>

            <mat-form-field>
               <input
                  matInput
                  formControlName="phone"
                  (keydown.enter)="onFilter(); $event.stopPropagation()"
               />
               <mat-label>{{ 'Phone' | translate }}</mat-label>
            </mat-form-field>

            <mat-form-field>
               <input
                  matInput
                  formControlName="email"
                  (keydown.enter)="onFilter(); $event.stopPropagation()"
               />
               <mat-label>{{ 'Email' | translate }}</mat-label>
            </mat-form-field>

            <mat-form-field>
               <input
                  matInput
                  formControlName="taxNumber"
                  (keydown.enter)="onFilter(); $event.stopPropagation()"
               />
               <mat-label>{{ 'Tax number' | translate }}</mat-label>
            </mat-form-field>

            <mat-form-field>
               <input
                  matInput
                  formControlName="createdAtFrom"
                  [matDatepicker]="createdAtFromPicker"
                  (input)="onParsedFilterDateInput($event, 'createdAtFrom')"
                  (keydown.enter)="onFilter(); $event.stopPropagation()"
               />
               <mat-label>{{ 'Created at from' | translate }}</mat-label>
               <mat-datepicker-toggle matSuffix [for]="createdAtFromPicker"></mat-datepicker-toggle>
               <mat-datepicker #createdAtFromPicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field>
               <input
                  matInput
                  formControlName="createdAtTo"
                  [matDatepicker]="createdAtToPicker"
                  (input)="onParsedFilterDateInput($event, 'createdAtTo')"
                  (keydown.enter)="onFilter(); $event.stopPropagation()"
               />
               <mat-label>{{ 'Created at to' | translate }}</mat-label>
               <mat-datepicker-toggle matSuffix [for]="createdAtToPicker"></mat-datepicker-toggle>
               <mat-datepicker #createdAtToPicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field>
               <mat-label>{{ 'Start date from' | translate }}</mat-label>
               <input
                  matInput
                  formControlName="startDateFrom"
                  [matDatepicker]="startDateFromPicker"
                  (input)="onParsedFilterDateInput($event, 'startDateFrom')"
                  (keydown.enter)="onFilter(); $event.stopPropagation()"
               />
               <mat-datepicker-toggle matSuffix [for]="startDateFromPicker"></mat-datepicker-toggle>
               <mat-datepicker #startDateFromPicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field>
               <mat-label>{{ 'Start date to' | translate }}</mat-label>
               <input
                  matInput
                  formControlName="startDateTo"
                  [matDatepicker]="startDateToPicker"
                  (input)="onParsedFilterDateInput($event, 'startDateTo')"
                  (keydown.enter)="onFilter(); $event.stopPropagation()"
               />
               <mat-datepicker-toggle matSuffix [for]="startDateToPicker"></mat-datepicker-toggle>
               <mat-datepicker #startDateToPicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field>
               <input
                  matInput
                  formControlName="loginLinkDateFrom"
                  [matDatepicker]="loginLinkDateFromPicker"
                  (input)="onParsedFilterDateInput($event, 'loginLinkDateFrom')"
                  (keydown.enter)="onFilter(); $event.stopPropagation()"
               />
               <mat-label>{{ 'Login link date from' | translate }}</mat-label>
               <mat-datepicker-toggle
                  matSuffix
                  [for]="loginLinkDateFromPicker"
               ></mat-datepicker-toggle>
               <mat-datepicker #loginLinkDateFromPicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field>
               <input
                  matInput
                  formControlName="loginLinkDateTo"
                  [matDatepicker]="loginLinkDateToPicker"
                  (input)="onParsedFilterDateInput($event, 'loginLinkDateTo')"
                  (keydown.enter)="onFilter(); $event.stopPropagation()"
               />
               <mat-label>{{ 'Login link date to' | translate }}</mat-label>
               <mat-datepicker-toggle
                  matSuffix
                  [for]="loginLinkDateToPicker"
               ></mat-datepicker-toggle>
               <mat-datepicker #loginLinkDateToPicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field>
               <input
                  matInput
                  formControlName="reminderDateFrom"
                  [matDatepicker]="reminderDateFromPicker"
                  (input)="onParsedFilterDateInput($event, 'reminderDateFrom')"
                  (keydown.enter)="onFilter(); $event.stopPropagation()"
               />
               <mat-label>{{ 'Reminder date from' | translate }}</mat-label>
               <mat-datepicker-toggle
                  matSuffix
                  [for]="reminderDateFromPicker"
               ></mat-datepicker-toggle>
               <mat-datepicker #reminderDateFromPicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field>
               <input
                  matInput
                  formControlName="reminderDateTo"
                  [matDatepicker]="reminderDateToPicker"
                  (input)="onParsedFilterDateInput($event, 'reminderDateTo')"
                  (keydown.enter)="onFilter(); $event.stopPropagation()"
               />
               <mat-label>{{ 'Reminder date to' | translate }}</mat-label>
               <mat-datepicker-toggle
                  matSuffix
                  [for]="reminderDateToPicker"
               ></mat-datepicker-toggle>
               <mat-datepicker #reminderDateToPicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field style="max-width: 12vw">
               <input
                  matInput
                  formControlName="dataSupplementEmailDateFrom"
                  [matDatepicker]="dataSupplementEmailDateFromPicker"
                  (input)="onParsedFilterDateInput($event, 'dataSupplementEmailDateFrom')"
                  (keydown.enter)="onFilter(); $event.stopPropagation()"
               />
               <mat-label>{{ 'Data supplement email date from' | translate }}</mat-label>
               <mat-datepicker-toggle
                  matSuffix
                  [for]="dataSupplementEmailDateFromPicker"
               ></mat-datepicker-toggle>
               <mat-datepicker #dataSupplementEmailDateFromPicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field style="max-width: 12vw">
               <input
                  matInput
                  formControlName="dataSupplementEmailDateTo"
                  [matDatepicker]="dataSupplementEmailDateToPicker"
                  (input)="onParsedFilterDateInput($event, 'dataSupplementEmailDateTo')"
                  (keydown.enter)="onFilter(); $event.stopPropagation()"
               />
               <mat-label>{{ 'Data supplement email date to' | translate }}</mat-label>
               <mat-datepicker-toggle
                  matSuffix
                  [for]="dataSupplementEmailDateToPicker"
               ></mat-datepicker-toggle>
               <mat-datepicker #dataSupplementEmailDateToPicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field>
               <mat-label>{{ 'Approved at from' | translate }}</mat-label>

               <input
                  matInput
                  formControlName="approvedAtFrom"
                  [matDatepicker]="approvedAtFromPicker"
                  (input)="onParsedFilterDateInput($event, 'approvedAtFrom')"
                  (keydown.enter)="onFilter(); $event.stopPropagation()"
               />
               <mat-datepicker-toggle
                  matSuffix
                  [for]="approvedAtFromPicker"
               ></mat-datepicker-toggle>
               <mat-datepicker #approvedAtFromPicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field>
               <mat-label>{{ 'Approved at to' | translate }}</mat-label>
               <input
                  matInput
                  formControlName="approvedAtTo"
                  [matDatepicker]="approvedAtToPicker"
                  (input)="onParsedFilterDateInput($event, 'approvedAtTo')"
                  (keydown.enter)="onFilter(); $event.stopPropagation()"
               />
               <mat-datepicker-toggle matSuffix [for]="approvedAtToPicker"></mat-datepicker-toggle>
               <mat-datepicker #approvedAtToPicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field>
               <input
                  matInput
                  formControlName="syncDateFrom"
                  [matDatepicker]="syncDateFromPicker"
                  (input)="onParsedFilterDateInput($event, 'syncDateFrom')"
                  (keydown.enter)="onFilter(); $event.stopPropagation()"
               />
               <mat-label>{{ 'Sync date from' | translate }}</mat-label>
               <mat-datepicker-toggle matSuffix [for]="syncDateFromPicker"></mat-datepicker-toggle>
               <mat-datepicker #syncDateFromPicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field>
               <input
                  matInput
                  formControlName="syncDateTo"
                  [matDatepicker]="syncDateToPicker"
                  (input)="onParsedFilterDateInput($event, 'syncDateTo')"
                  (keydown.enter)="onFilter(); $event.stopPropagation()"
               />
               <mat-label>{{ 'Sync date to' | translate }}</mat-label>
               <mat-datepicker-toggle matSuffix [for]="syncDateToPicker"></mat-datepicker-toggle>
               <mat-datepicker #syncDateToPicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field>
               <mat-select
                  formControlName="paymentMethod"
                  (keydown.enter)="onFilter(); $event.stopPropagation()"
                  placeholder="Payment method"
                  #paymentMethodSelect
               >
                  <mat-option *ngFor="let pm of paymentMethods" [value]="pm">
                     {{ 'paymentMethod.' + pm | translate }}
                  </mat-option>
               </mat-select>

               <mat-label>{{ 'Payment method' | translate }}</mat-label>
               <button
                  *ngIf="filterForm.get('paymentMethod')?.value"
                  matSuffix
                  mat-icon-button
                  aria-label="Clear"
                  type="button"
                  (click)="
                     filterForm.get('paymentMethod')?.reset();
                     paymentMethodSelect.focus();
                     $event.stopPropagation()
                  "
               >
                  <mat-icon>close</mat-icon>
               </button>
            </mat-form-field>

            <mat-form-field>
               <mat-select
                  formControlName="language"
                  (keydown.enter)="onFilter(); $event.stopPropagation()"
                  placeholder="Nyelv"
                  #languageSelect
               >
                  <mat-option *ngFor="let lang of languages" [value]="lang">
                     {{ lang | translate }}
                  </mat-option>
               </mat-select>

               <mat-label>{{ 'Language' | translate }}</mat-label>

               <button
                  *ngIf="filterForm.get('language')?.value"
                  matSuffix
                  mat-icon-button
                  aria-label="Clear"
                  type="button"
                  (click)="
                     filterForm.get('language')?.reset();
                     languageSelect.focus();
                     $event.stopPropagation()
                  "
               >
                  <mat-icon>close</mat-icon>
               </button>
            </mat-form-field>

            <mat-form-field>
               <input
                  matInput
                  formControlName="approvedBy"
                  (keydown.enter)="onFilter(); $event.stopPropagation()"
               />
               <mat-label>{{ 'Approved by' | translate }}</mat-label>
            </mat-form-field>

            <mat-form-field>
               <input
                  matInput
                  formControlName="comment"
                  (keydown.enter)="onFilter(); $event.stopPropagation()"
               />
               <mat-label>{{ 'Comment' | translate }}</mat-label>
            </mat-form-field>

            <mat-form-field style="max-width: 12vw">
               <input
                  matInput
                  formControlName="check"
                  (keydown.enter)="onFilter(); $event.stopPropagation()"
               />
               <mat-label>{{ 'Check' | translate }}</mat-label>
            </mat-form-field>

            <mat-form-field style="max-width: 12vw">
               <input
                  matInput
                  formControlName="id"
                  type="number"
                  (keydown.enter)="onFilter(); $event.stopPropagation()"
               />
               <mat-label>{{ 'Id' | translate }}</mat-label>
            </mat-form-field>

            <button
               mat-flat-button
               style="border-radius: 1000px; max-height: 40px; min-width: 6vw"
               color="primary"
               class="mat-secondary"
               type="button"
               (click)="onFilter()"
            >
               {{ 'Filter' | translate }}
            </button>

            <button
               mat-flat-button
               style="border-radius: 1000px; max-height: 40px; min-width: 6vw"
               color="warn"
               type="button"
               (click)="onClearFilter()"
            >
               {{ 'Clear filter' | translate }}
            </button>
         </form>
      </mat-expansion-panel>
      <br />
      <div class="mat-elevation-z8">
      <mat-paginator
         [length]="totalRows"
         [pageSize]="pageSize"
         [pageIndex]="pageIndex"
         [pageSizeOptions]="[5, 10, 25, 50]"
         showFirstLastButtons
         (page)="onPageChange($event)"
      >
      </mat-paginator>
      <table mat-table [dataSource]="dataSource" multiTemplateDataRows [width]="'100%'">
         <!--first row-->
         <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef class="text-center p0">{{ 'Id' | translate }}</th>
            <td mat-cell *matCellDef="let element" class="text-center p0">
               {{ element.id }}
            </td>
         </ng-container>

         <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef class="text-left"
               ><b>{{ 'Student name' | translate }}</b></th
            >
            <td mat-cell *matCellDef="let element" class="text-left">
               <ng-container *ngIf="rowAddInProgress?.id === element.id; else staticDate">
                  <mat-form-field style="max-width: 100px">
                     <input matInput [(ngModel)]="rowAddInProgress!.name" class="create" required />
                  </mat-form-field>
               </ng-container>
               <ng-template #staticDate>
                  <b>{{ element.name }}</b>
               </ng-template>
            </td>
         </ng-container>
         <ng-container matColumnDef="birthDate" class="text-right">
            <th mat-header-cell *matHeaderCellDef class="text-center">{{
               'Birth date' | translate
            }}</th>
            <td mat-cell *matCellDef="let element" class="text-center">
               <ng-container *ngIf="rowAddInProgress?.id === element.id; else staticDate">
                  <mat-form-field style="max-width: 100px">
                     <input
                        matInput
                        [matDatepicker]="picker"
                        [(ngModel)]="rowAddInProgress!.birthDate"
                        required
                        (input)="onRawDateInput($event, rowAddInProgress, 'birthDate')"
                        class="create"
                     />
                  </mat-form-field>

                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
               </ng-container>

               <ng-template #staticDate>
                  {{ element.birthDate | formatDateIso }}
               </ng-template>
            </td>
         </ng-container>

         <ng-container matColumnDef="taxNumber">
            <th mat-header-cell *matHeaderCellDef class="text-center" rowspan="2">
               {{ 'Tax number' | translate }}</th
            >
            <td mat-cell *matCellDef="let element" class="text-center" rowspan="2">
               {{ element.taxNumber }}
            </td>
         </ng-container>

         <ng-container matColumnDef="area">
            <th mat-header-cell *matHeaderCellDef class="text-center">{{ 'Area' | translate }}</th>
            <td mat-cell *matCellDef="let element" class="text-center">
               <ng-container *ngIf="rowEditInProgress?.id === element.id; else checkRowAdd">
                  <mat-select
                     [(ngModel)]="rowEditInProgress!.area"
                     placeholder="Terület"
                     tabindex="1"
                     class="edit"
                     [disabled]="!hasResource(Resources.CTAreaEdit) || element.deleted"
                  >
                     <mat-option *ngFor="let area of areas" [value]="area.code">
                        {{ area.value }}
                     </mat-option>
                  </mat-select>
               </ng-container>
               <ng-template #checkRowAdd>
                  <ng-container *ngIf="rowAddInProgress?.id === element.id; else staticDate">
                     <mat-select
                        [(ngModel)]="rowAddInProgress!.area"
                        placeholder="Terület"
                        class="create"
                        required
                     >
                        <mat-option *ngFor="let area of areas" [value]="area.code">
                           {{ area.value }}
                        </mat-option>
                     </mat-select>
                  </ng-container>
               </ng-template>
               <ng-template #staticDate>
                  {{ getAreaName(element.area) }}
               </ng-template>
            </td>
         </ng-container>

         <ng-container matColumnDef="startDate">
            <th mat-header-cell *matHeaderCellDef class="text-center">{{
               'Start date' | translate
            }}</th>
            <td mat-cell *matCellDef="let element" class="text-center">
               <ng-container *ngIf="rowEditInProgress?.id === element.id; else staticDate">
                  <mat-form-field style="max-width: 100px">
                     <input
                        matInput
                        [matDatepicker]="picker"
                        [(ngModel)]="rowEditInProgress!.startDate"
                        tabindex="3"
                        (input)="onRawDateInput($event, rowEditInProgress, 'startDate')"
                        class="edit"
                        [disabled]="!hasResource(Resources.CTEducationStartEdit) || element.deleted"
                     />
                  </mat-form-field>

                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
               </ng-container>

               <ng-template #staticDate>
                  {{ element.startDate | formatDateIso }}
               </ng-template>
            </td>
         </ng-container>

         <ng-container matColumnDef="rowStatus">
            <th mat-header-cell *matHeaderCellDef class="text-center">{{
               'Row status' | translate
            }}</th>
            <td mat-cell *matCellDef="let element" class="text-center">
               {{ element.rowStatus | translate }}
            </td>
         </ng-container>
         <ng-container matColumnDef="studentStatus">
            <th mat-header-cell *matHeaderCellDef class="text-center">{{
               'Student status' | translate
            }}</th>
            <td mat-cell *matCellDef="let element" class="text-center">
               {{ getStatus(element.studentStatus) | translate }}
            </td>
         </ng-container>
         <ng-container matColumnDef="approvedAt">
            <th mat-header-cell *matHeaderCellDef class="text-center">{{
               'Approved at' | translate
            }}</th>
            <td mat-cell *matCellDef="let element" class="text-center">
               {{ element.approvedAt | formatDateIso }}
            </td>
         </ng-container>
         <ng-container matColumnDef="paymentMethod">
            <th mat-header-cell *matHeaderCellDef class="text-center">
               {{ 'Payment method' | translate }}</th
            >
            <td mat-cell *matCellDef="let element" class="text-center">
               {{
                  (element.paymentMethod ? 'paymentMethod.' + element.paymentMethod : '')
                     | translate
               }}
            </td>
         </ng-container>
         <ng-container matColumnDef="syncDate">
            <th mat-header-cell *matHeaderCellDef class="text-center" rowspan="2">{{
               'Sync date' | translate
            }}</th>
            <td mat-cell *matCellDef="let element" class="text-center" rowspan="2">
               {{ element.syncDate | formatDateIso }}
            </td>
         </ng-container>
         <ng-container matColumnDef="comment">
            <th mat-header-cell *matHeaderCellDef class="text-center" rowspan="2"
               >{{ 'Comment' | translate }}
            </th>
            <td mat-cell *matCellDef="let element" class="text-center" rowspan="2">
               <ng-container *ngIf="rowEditInProgress?.id === element.id; else staticDate">
                  <mat-form-field style="max-width: 100px">
                     <input
                        matInput
                        [(ngModel)]="rowEditInProgress!.comment"
                        tabindex="5"
                        class="edit"
                        [disabled]="!hasResource(Resources.CTProjectEdit)"
                     />
                  </mat-form-field>
               </ng-container>
               <ng-template #staticDate>
                  {{ element.comment }}
               </ng-template>
            </td>
         </ng-container>
         <ng-container matColumnDef="createdAt">
            <th mat-header-cell *matHeaderCellDef class="text-center">{{
               'Created at' | translate
            }}</th>
            <td mat-cell *matCellDef="let element" class="text-center">
               {{ element.createdAt | formatDateIso }}
            </td>
         </ng-container>

         <ng-container matColumnDef="op">
            <th mat-header-cell *matHeaderCellDef class="text-center p0" rowspan="2">
               <div class="action-buttons">
                  <button
                     mat-icon-button
                     style="color: var(--chaos-green)"
                     (click)="onAddColumn()"
                     [disabled]="!!rowAddInProgress || !this.hasResource(Resources.CTAddNewRow)"
                  >
                     <mat-icon>add</mat-icon>
                  </button>
               </div>
            </th>
            <td mat-cell *matCellDef="let element" class="text-center p0" rowspan="2">
               <ng-container
                  *ngIf="
                     (rowEditInProgress && rowEditInProgress.id === element.id) ||
                        (rowAddInProgress && rowAddInProgress.id === element.id);
                     else actionMenu
                  "
               >
                  <div class="action-buttons">
                     <div>
                        <button
                           mat-icon-button
                           (click)="onSave()"
                           [disabled]="!canBeSaved()"
                           [ngClass]="{ green: canBeSaved(), gray: !canBeSaved() }"
                           tabindex="6"
                        >
                           <mat-icon>check</mat-icon>
                        </button></div
                     >
                     <button mat-icon-button color="warn" (click)="onCancel()" tabindex="7">
                        <mat-icon>close</mat-icon>
                     </button>
                  </div>
               </ng-container>
               <ng-template #actionMenu>
                  <button
                     mat-icon-button
                     [matMenuTriggerFor]="menu"
                     [matMenuTriggerData]="{ element: element }"
                  >
                     <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #menu="matMenu" class="compact-menu">
                     <ng-template matMenuContent let-element="element">
                        <button
                           mat-menu-item
                           (click)="openEmailTemplateSendDialog(element, 'enrollment')"
                           [disabled]="sendEnrollmentLinkDisabled(element)"
                        >
                           <mat-icon>send</mat-icon>
                           <span> {{ 'Send link for enrollment' | translate }}</span>
                        </button>
                        <button
                           mat-menu-item
                           (click)="openEmailTemplateSendDialog(element, 'reminder')"
                           [disabled]="sendReminderEmailDisabled(element)"
                        >
                           <mat-icon>warning</mat-icon>
                           <span>{{ 'Send reminder link' | translate }}</span>
                        </button>
                        <button
                           mat-menu-item
                           [disabled]="joinRowDisabled(element)"
                           (click)="onJoinRow(element)"
                        >
                           <mat-icon>link</mat-icon>
                           <span>{{ 'Join rows' | translate }}</span>
                        </button>
                        <button
                           mat-menu-item
                           (click)="closeRow(element.id)"
                           [disabled]="closeRowDisabled(element)"
                        >
                           <mat-icon>lock</mat-icon>
                           <span>{{ 'Close' | translate }}</span>
                        </button>

                        <button
                           mat-menu-item
                           (click)="navigateToHistory(element.id)"
                           [disabled]="!hasResource(Resources.CTHistoryMenu)"
                        >
                           <mat-icon>history</mat-icon>
                           <span>{{ 'History' | translate }}</span>
                        </button>
                        <button
                           mat-menu-item
                           (click)="onCopy(element)"
                        >
                           <mat-icon>file_copy</mat-icon>
                           <span>{{ 'Copy' | translate }}</span>
                        </button>
                     </ng-template>
                  </mat-menu>
               </ng-template>
            </td>
         </ng-container>

         <!--second row -->
         <ng-container matColumnDef="createdBy">
            <th mat-header-cell *matHeaderCellDef class="text-center"
               >{{ 'Created by' | translate }}
            </th>
            <td mat-cell *matCellDef="let element" class="text-center">
               {{ element.createdBy }}
            </td>
         </ng-container>
         <ng-container matColumnDef="phone">
            <th mat-header-cell *matHeaderCellDef class="text-center">{{ 'Phone' | translate }}</th>
            <td mat-cell *matCellDef="let element" class="text-center">
               <ng-container *ngIf="rowAddInProgress?.id === element.id; else staticDate">
                  <mat-form-field style="max-width: 100px">
                     <input
                        matInput
                        [(ngModel)]="rowAddInProgress!.phone"
                        required
                        class="create"
                     />
                  </mat-form-field>
               </ng-container>
               <ng-template #staticDate>
                  {{ element.phone }}
               </ng-template>
            </td>
         </ng-container>
         <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef class="text-center">{{ 'Email' | translate }}</th>
            <td mat-cell *matCellDef="let element" class="text-center">
               <ng-container *ngIf="rowAddInProgress?.id === element.id; else staticDate">
                  <mat-form-field>
                     <input
                        matInput
                        [(ngModel)]="rowAddInProgress!.email"
                        required
                        class="create"
                     />
                  </mat-form-field>
               </ng-container>
               <ng-template #staticDate>
                  {{ element.email }}
               </ng-template>
            </td>
         </ng-container>
         <ng-container matColumnDef="project">
            <th mat-header-cell *matHeaderCellDef class="text-center">{{
               'Project' | translate
            }}</th>
            <td mat-cell *matCellDef="let element" class="text-center">
               <ng-container *ngIf="rowEditInProgress?.id === element.id; else checkAddRow">
                  <mat-form-field style="max-width: 100px">
                     <input
                        matInput
                        [(ngModel)]="rowEditInProgress!.project"
                        tabindex="2"
                        class="edit"
                        [disabled]="!hasResource(Resources.CTProjectEdit) || element.deleted"
                     />
                  </mat-form-field>
               </ng-container>
               <ng-template #checkAddRow>
                  <ng-container *ngIf="rowAddInProgress?.id === element.id; else staticDate">
                     <mat-form-field style="max-width: 100px">
                        <input
                           matInput
                           [(ngModel)]="rowAddInProgress!.project"
                           required
                           class="create"
                        />
                     </mat-form-field>
                  </ng-container>
               </ng-template>
               <ng-template #staticDate>
                  {{ element.project }}
               </ng-template>
            </td>
         </ng-container>

         <ng-container matColumnDef="language">
            <th mat-header-cell *matHeaderCellDef class="text-center">{{
               'Language' | translate
            }}</th>
            <td mat-cell *matCellDef="let element" class="text-center">
               <ng-container *ngIf="rowEditInProgress?.id === element.id; else checkAddRow">
                  <mat-select
                     [(ngModel)]="rowEditInProgress!.language"
                     placeholder="Nyelv"
                     tabindex="4"
                     class="edit"
                     [disabled]="!hasResource(Resources.CTLanguageEdit) || element.deleted"
                  >
                     <mat-option *ngFor="let lang of languages" [value]="lang">
                        {{ lang | translate }}
                     </mat-option>
                  </mat-select>
               </ng-container>
               <ng-template #checkAddRow>
                  <ng-container *ngIf="rowAddInProgress?.id === element.id; else staticLang">
                     <mat-select
                        [(ngModel)]="rowAddInProgress!.language"
                        placeholder="Nyelv"
                        required
                        class="create"
                     >
                        <mat-option *ngFor="let lang of languages" [value]="lang">
                           {{ lang | translate }}
                        </mat-option>
                     </mat-select>
                  </ng-container>
               </ng-template>
               <ng-template #staticLang>
                  {{ element.language | translate }}
               </ng-template>
            </td>
         </ng-container>

         <ng-container matColumnDef="loginLinkDate">
            <th mat-header-cell *matHeaderCellDef class="text-center wrap-header max-width">{{
               'Login link date' | translate
            }}</th>
            <td mat-cell *matCellDef="let element" class="text-center">
               {{ element.loginLinkDate | formatDateIso }}
            </td>
         </ng-container>
         <ng-container matColumnDef="reminderDate">
            <th mat-header-cell *matHeaderCellDef class="text-center">{{
               'Reminder date' | translate
            }}</th>
            <td mat-cell *matCellDef="let element" class="text-center">
               {{ element.reminderDate | formatDateIso }}
            </td>
         </ng-container>

         <ng-container matColumnDef="approvedBy">
            <th mat-header-cell *matHeaderCellDef class="text-center">{{
               'Approved by' | translate
            }}</th>
            <td mat-cell *matCellDef="let element" class="text-center">
               {{ element.approvedBy }}
            </td>
         </ng-container>
         <ng-container matColumnDef="dataSupplementEmailDate">
            <th mat-header-cell *matHeaderCellDef class="text-center wrap-header max-width">{{
               'Data supplement email date' | translate
            }}</th>
            <td mat-cell *matCellDef="let element" class="text-center">
               {{ element.dataSupplementEmailDate | formatDateIso }}
            </td>
         </ng-container>
         <ng-container matColumnDef="check">
            <th mat-header-cell *matHeaderCellDef class="text-center" style="padding-right: 0px">{{
               'Check' | translate
            }}</th>
            <td mat-cell *matCellDef="let element" class="text-center">
               <ng-container *ngIf="rowEditInProgress?.id === element.id; else staticDate">
                  <mat-form-field style="max-width: 100px">
                     <input
                        matInput
                        [(ngModel)]="rowEditInProgress!.check"
                        tabindex="5"
                        class="edit"
                        [disabled]="!hasResource(Resources.CTCheckEdit)"
                     />
                  </mat-form-field>
               </ng-container>
               <ng-template #staticDate>
                  {{ element.check }}
               </ng-template>
            </td>
         </ng-container>
         <tr
            mat-header-row
            *matHeaderRowDef="firstHeaderRow; sticky: true"
            class="first-header-row"
         ></tr>
         <tr
            mat-header-row
            *matHeaderRowDef="secondHeaderRow; sticky: true"
            class="second-header-row"
         ></tr>
         <tr
            mat-row
            *matRowDef="let row; columns: firstHeaderRow"
            class="first-row"
            [ngClass]="{
               'edit-row': rowEditInProgress && rowEditInProgress.id === row.id,
               'new-row': rowAddInProgress && rowAddInProgress.id === row.id,
               'deleted-row': row.deleted || isUnsuccessful(row),
               'has-pos-match': row.hasPossibleMatch && !row.deleted,
               success: isSuccess(row),
               'in-progress-row': isOpenAndNotNone(row)
            }"
            (dblclick)="onEdit(row)"
         ></tr>

         <tr
            mat-row
            *matRowDef="let row; columns: secondHeaderRow"
            class="second-row"
            [ngClass]="{
               'edit-row': rowEditInProgress && rowEditInProgress.id === row.id,
               'new-row': rowAddInProgress && rowAddInProgress.id === row.id,
               'deleted-row': row.deleted || isUnsuccessful(row),
               'has-pos-match': row.hasPossibleMatch && !row.deleted,
               success: isSuccess(row),
               'in-progress-row': isOpenAndNotNone(row)
            }"
            (dblclick)="onEdit(row)"
         ></tr>
      </table>
      <mat-paginator
         [length]="totalRows"
         [pageSize]="pageSize"
         [pageIndex]="pageIndex"
         [pageSizeOptions]="[5, 10, 25, 50]"
         showFirstLastButtons
         (page)="onPageChange($event)"
      >
      </mat-paginator>
      </div>
   </div>
</div>
